import React from 'react'

import Portal from './portal'
import bm from '../utils/bm'
import './modal.scss'


export default function Modal({children, nopad, stretch, onClose, wide}) {
    React.useEffect(() => {
        const prev = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return () => { document.body.style.overflow = prev }
    }, [])

    const ref = React.useRef()
    const innerRef = React.useRef()
    const mouseDownRef = React.useRef(false)
    const animteRef = React.useRef(false)
    const prevRef = React.useRef()
    const prevInneRef = React.useRef()
    const sourceRectRef = React.useRef()
    const targetRectRef = React.useRef()


    function handleMouseDown(event) {
        if (event.target === ref.current) {
            mouseDownRef.current = true
        }
    }

    function handleCloseOverlay(event) {
        event.stopPropagation()
        if (event.target === ref.current && mouseDownRef.current && onClose) {
            onClose(event)
        }
        mouseDownRef.current = false
    }


    function setModalRef(element) {
        prevRef.current = ref.current
        ref.current = element
    }

    function setInnerRef(element) {
        prevInneRef.current = innerRef.current
        innerRef.current = element
    }

    return <div
        className="modal"
        onClick={handleCloseOverlay}
        onMouseDown={handleMouseDown}
        ref={setModalRef}
    >
        <div className={bm("modal__inner", {stretch, nopad}, wide)} ref={setInnerRef} >
            {children}
        </div>
    </div>
}
